import * as React from 'react';
export var IconEditCircle = React.forwardRef(function IconEditCircle({ size = 24, ...other }, ref) {
    if (size === 16 || size === '16') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '16',
            height: '16',
            viewBox: '0 0 16 16',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-sm': true
        }, /*#__PURE__*/ React.createElement('path', {
            d: 'm8.068 6.36 1.584 1.56-2.348 2.349a.599.599 0 0 1-.236.145l-1.73.573a.257.257 0 0 1-.325-.324l.573-1.731a.6.6 0 0 1 .145-.235L8.068 6.36Zm1.034-1.034-.327.327 1.584 1.56.315-.315a1.112 1.112 0 0 0-1.572-1.572Z',
            fill: 'currentColor',
            'data-global-icon-size-sm': true
        }), /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1ZM2.5 8a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z',
            fill: 'currentColor',
            'data-global-icon-size-sm': true
        }));
    }
    if (size === 24 || size === '24') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-md': true
        }, /*#__PURE__*/ React.createElement('path', {
            d: 'm12.032 9.872 2.112 2.08-3.073 3.073a.796.796 0 0 1-.314.194l-2.307.764a.343.343 0 0 1-.433-.432l.764-2.308a.8.8 0 0 1 .194-.314l3.057-3.057Zm1.438-1.438-.378.377 2.112 2.08.362-.36a1.482 1.482 0 0 0-2.096-2.097Z',
            fill: 'currentColor',
            'data-global-icon-size-md': true
        }), /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-7.5 9a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0Z',
            fill: 'currentColor',
            'data-global-icon-size-md': true
        }));
    }
    if (size === 32 || size === '32') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-lg': true
        }, /*#__PURE__*/ React.createElement('path', {
            d: 'm12.032 9.872 2.112 2.08-3.073 3.073a.796.796 0 0 1-.314.194l-2.307.764a.343.343 0 0 1-.433-.432l.764-2.308a.8.8 0 0 1 .194-.314l3.057-3.057Zm1.438-1.438-.378.377 2.112 2.08.362-.36a1.482 1.482 0 0 0-2.096-2.097Z',
            fill: 'currentColor',
            'data-global-icon-size-lg': true
        }), /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-7.5 9a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0Z',
            fill: 'currentColor',
            'data-global-icon-size-lg': true
        }));
    }
});
